<app-performanceprofiles-table [performanceProfiles]="performanceProfiles$ | async"
    ></app-performanceprofiles-table>